import { render, staticRenderFns } from "./StaffBroadcast.vue?vue&type=template&id=5eb3b42c&scoped=true"
import script from "./StaffBroadcast.vue?vue&type=script&lang=js"
export * from "./StaffBroadcast.vue?vue&type=script&lang=js"
import style0 from "./StaffBroadcast.vue?vue&type=style&index=0&id=5eb3b42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3b42c",
  null
  
)

export default component.exports